var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      staticClass: "svg-icon",
      attrs: { width: _vm.width, height: _vm.height, viewBox: _vm.viewBox },
      on: {
        click: function ($event) {
          return _vm.$emit("click", $event)
        },
      },
    },
    [_c("path", { attrs: { d: _vm.path } })]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }